import { UserPermission } from 'enums/UserPermission';
import { UserPermissionState } from 'enums/UserPermissionState';

import { requestBrowserPermission } from './native';

export const getUserPermissionState = async (
    name: UserPermission,
): Promise<UserPermissionState> => {
    const permission = await requestBrowserPermission({ name });

    if (permission?.state) {
        return (
            permission.state === 'prompt' ? 'not_granted' : permission.state
        ) as UserPermissionState;
    }

    return UserPermissionState.NotGranted;
};
